import { createOpowerWidget } from '../utils/createOpowerWaytoSaveWidget';

const NextBestActionWidget = createOpowerWidget(
  'opower-widget-next-best-action',
);

export default NextBestActionWidget;
